import React, { createContext } from 'react';
import EnvironmentContextInterface from './EnvironmentContextInterface';
import initialContextState from './initialContextState';

const EnvironmentContext: React.Context<EnvironmentContextInterface> =
  createContext<EnvironmentContextInterface>(initialContextState);

export default EnvironmentContext;
